module.exports = __webpack_public_path__ + "img/img09e.55686e51.png";